import type { Moment } from 'moment'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'

const DateTime = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
`

const Date = styled.div`
  flex: 1;
`
const Time = styled.div`
  flex: 1;
`

type Props = {
  date?: Moment
  time?: Moment
  day?: number
}

function SummaryDateTime({ date, time, day }: Props) {
  const intl = useIntl()
  const timeFormat = useRegionTimeFormat()

  if (!date && !time && !day) return null

  const dayLabel = intl.formatMessage(
    {
      id: 'KgtXN8GY1uRKZFP7ok17',
      defaultMessage: 'Day {day}',
      description: 'Day number label in trip itinerary summary in the trip planner',
    },
    { day },
  )

  return (
    <DateTime>
      {day && (
        <Date>
          <BodyText weight="bold" variant="medium">
            {intl.formatMessage({
              id: 'el9QYjSit5Ryee1zMAFX',
              defaultMessage: 'Day',
              description: 'Section heading for day number in trip itinerary in the trip planner item editor modal',
            })}
          </BodyText>
          <BodyText variant="large">{dayLabel}</BodyText>
        </Date>
      )}
      {!day && date && (
        <Date>
          <BodyText weight="bold" variant="medium">
            {intl.formatMessage({
              id: '4Op1aaAvBRp5RUUxz1_x',
              defaultMessage: 'Date',
              description: 'Section heading for date in trip itinerary in the trip planner',
            })}
          </BodyText>
          <BodyText variant="large">
            {date?.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
          </BodyText>
        </Date>
      )}
      {time && (
        <Time>
          <BodyText weight="bold" variant="medium">
            {intl.formatMessage({
              id: 'TA9T47FGm-d5HU-3X-Ch',
              defaultMessage: 'Time',
              description: 'Section heading for time in trip itinerary in the trip planner',
            })}
          </BodyText>
          <BodyText variant="large">{time?.format(timeFormat)}</BodyText>
        </Time>
      )}
    </DateTime>
  )
}

export default SummaryDateTime
